module.exports = __webpack_public_path__ + "img/catalog-definition.8bdee8aa.gif";